import { Typography } from '@mui/material';
import TimelineItem from './TimelineItem';

export default function TimelineComponent({ list, rating, viewFull = false }
    : { list: any, rating: string, viewFull?: boolean }) {
    if (list === null)
        return <Typography variant='body1' fontStyle={'italic'}>
            Timeline is not available.
        </Typography>

    const parsedJson = JSON.parse(list)
    const limitedTimeline = viewFull ? parsedJson : parsedJson.length > 5 ? parsedJson.slice(0, 5) : parsedJson;
    return <>
        {
            list.length > 0 && limitedTimeline.map((item: any, index: number) => {
                return <TimelineItem key={index} date={item.date} content={item.summary} rating={rating}></TimelineItem>
            })
        }
    </>
}
